import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'polaris-classification-notice-modal',
  templateUrl: './classification-notice-modal.component.html',
  styleUrls: ['./classification-notice-modal.component.scss'],
})
export class ClassificationNoticeModalComponent {
  @Input() show = false;
  @Output() closeModal = new EventEmitter<void>();
  @ViewChild('modalDialog') modalDialog: ElementRef<HTMLElement>;
  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    if (!this.show || !this.modalDialog) {
      return;
    }

    const clickTarget = event.target as Node;

    if (!this.modalDialog.nativeElement.contains(clickTarget)) {
      this.onClose();
    }
  }

  public onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  public onClose(): void {
    this.closeModal.emit();
  }
}
